import axios, { AxiosResponse } from 'axios';
import { CHECK_EXISTING_ACCOUNT } from './ZoryveDirect.config';
import { API, SESSION_ID } from '../../config';
import { GLOBALS } from '../../globals';

const ZORYVE_DIRECT_QUICK_ENROLLMENT_API_URL = `${API}/products/risrx/${SESSION_ID}/quick-enroll`;
const ZORYVE_DIRECT_UPDATE_CONTACT_URL = `${API}/products/risrx/${SESSION_ID}/update-contact`;
const ZORYVE_DIRECT_SEND_CARD_URL = `${API}/products/risrx/${SESSION_ID}/send-card`;

export const createEnrolment = async (): Promise<AxiosResponse> => {
  try {
    const response = await axios.post(ZORYVE_DIRECT_QUICK_ENROLLMENT_API_URL);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};

export const createEnrollment = async (): Promise<AxiosResponse> => {
  try {
    const response = await axios.post(ZORYVE_DIRECT_QUICK_ENROLLMENT_API_URL);
    GLOBALS.enrollmentResponse = response.data;
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};

export const updateContact = async (): Promise<AxiosResponse> => {
  try {
    const response = await axios.post(ZORYVE_DIRECT_UPDATE_CONTACT_URL);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};

export const sendEmail = async (): Promise<AxiosResponse> => {
  try {
    const response = await axios.post(ZORYVE_DIRECT_SEND_CARD_URL, {
      reminderTypes: ['email'],
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};

export const sendText = async (): Promise<AxiosResponse> => {
  try {
    const response = await axios.post(`${API}/products/risrx/${SESSION_ID}/send-card`, {
      reminderTypes: ['text'],
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};

export const checkExistingAccount = async (): Promise<AxiosResponse> => {
  try {
    const response = await axios.get(CHECK_EXISTING_ACCOUNT);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};
